<template>
  <el-dialog
    :title="$t('deleteAffiliateUser.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center">
      <p>{{ $t('deleteAffiliateUser.confirmDeleteAffiliateUser') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('deleteAffiliateUser.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAffiliateUser">{{ $t('deleteAffiliateUser.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAffiliateUser } from '@/api/affiliate/affiliateUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateUser',
  data() {
    return {
      dialogVisible: false,
      deleteAffiliateUserInfo: {}
    }
  },
  methods: {
    open(affiliateUser) {
      this.deleteAffiliateUserInfo = { ...affiliateUser }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteAffiliateUserInfo = {}
      console.log(this.deleteAffiliateUserInfo)
    },
    async deleteAffiliateUser() {
      try {
        this.deleteAffiliateUserInfo.shopId = getShopId()
        await deleteAffiliateUser(this.deleteAffiliateUserInfo)
        this.$emit('refresh')
        this.closeDialog()
        this.$message.success(this.$t('common.operationSuccess'))
      } catch (error) {
        console.error(error)
        this.$message.error(error.message || this.$t('common.operationFailed'))
      }
    }
  }
}
</script>